import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { COLORS } from '../../constants/theme';

const UploadArea = styled.div`
  border: 2px dashed #444;
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s;
  &:hover { border-color: ${COLORS.cyan}; }
`;

const UploadLabel = styled.p`
  color: #aaa;
  margin: 0 0 0.5rem;
  font-size: 0.9rem;
`;

const FileName = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 0.5rem;
  color: ${COLORS.cyan};
  font-size: 0.95rem;
`;

const ClearButton = styled.button`
  background: transparent;
  border: 1px solid #555;
  color: #aaa;
  border-radius: 4px;
  padding: 0.2rem 0.6rem;
  cursor: pointer;
  font-size: 0.8rem;
  &:hover { border-color: ${COLORS.error}; color: ${COLORS.error}; }
`;

const HiddenInput = styled.input`
  display: none;
`;

function SurveyUpload({ file, onFileChange }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  const handleClick = () => inputRef.current?.click();

  const handleChange = (e) => {
    const selected = e.target.files?.[0] || null;
    onFileChange(selected);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onFileChange(null);
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <UploadArea id="persona-form-survey-upload-037" onClick={handleClick}>
      <HiddenInput
        ref={inputRef}
        type="file"
        accept=".xlsx,.xls"
        onChange={handleChange}
      />
      <UploadLabel>{t('survey_upload_label')}</UploadLabel>
      {file ? (
        <FileName>
          <span>{file.name}</span>
          <ClearButton id="persona-form-survey-clear-038" onClick={handleClear}>
            {t('survey_clear')}
          </ClearButton>
        </FileName>
      ) : (
        <UploadLabel>{t('survey_upload_hint')}</UploadLabel>
      )}
    </UploadArea>
  );
}

export default SurveyUpload;
